document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = select.closest('[data-product-summary]')?.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const button = select.closest('form')?.querySelector('[data-add-to-cart]');
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
      }
    });
  });
});
